const PartyType = {
  Borrower: 1,
  Guarantor: 2,
  BorrowerAndGuarantor: 3,
};

export default PartyType;
